// IE 11 polyfill
import 'core-js/shim';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import App from './containers/App';
import store, { history } from './services/ReduxStore';
import registerServiceWorker from './registerServiceWorker';
import { I18nextProvider } from "react-i18next";
import i18n from './services/i18n';

import './App.css';

const target = document.getElementById('root');

render(
	<Provider store={store}>
		<ConnectedRouter history={history}>
			<I18nextProvider i18n={i18n}>
				<App />
			</I18nextProvider>
		</ConnectedRouter>
	</Provider>,
	target
);
registerServiceWorker();
